module.exports={
    btn:{
        tips_reelect_btn:"Nový vzhled",
        cancel_btn:"Zrušení",
        tips_continue_dispose:"Upscale podporované obrázky",
        tips_return:"Nový vzhled",
        tips_upgrade:"Vylepšit",
        tips_yes:"OK",
        delete:"Vymazat",
        download:"Stažení",
        upload_image:"Nahrát obrázek",
        new_image:"Nový vzhled",
        save_all:"Uložit vše",
        cancel:"Probíhá zrušení",
        save:"Uložit",
        view_comparison:"Zobrazit srovnání",
        hide_comparison:"Skrýt srovnání",
        previous:"Předchozí",
        next:"Další",
        continue_download:"Uložit obrázky s vodoznaky",
        present:"Použít na tento obrázek",
        all_wait:"Použít na snímky v Čekání",
        all:"Použít na všechny obrázky",
        history:"Dějiny",
        login:"Přihlásit se",
    },
    tips:{
        please_upgrade:"Váš aktuální plán nepodporuje nahrávání ani převzorkování obrázků v dávkách. Upgradujte jej, abyste mohli využívat více výhod.",
        errorlistinfo:"Je vybráno XXX obrázků. Obrázky XXX jsou podporovány, ale obrázky XXX nejsou podporovány. Nepodporované obrázky jsou následující:",
        max:"Překročte maximální limit velikosti obrázku 10 MB!",
        max_size:"Překročte maximální limit délky strany obrázku 4096 pixelů!",
        continue_dispose:"Upscale podporované obrázky",
        please_multiple:"Vyberte prosím zvětšení",
        max_multiple:"* Váš obrázek bude zvětšen na maximálně 4K (nejdelší strana nepřesáhne 4096 pixelů).",
        title:"Název",
        reasons:"důvody",
        upload_type:"Není podporováno",
        used_up:"Počet uložení HD obrázků bez vodoznaků byl vyčerpán. Upgradujte svůj účet. Nebo můžete uložit HD obrázky s vodoznakem.",
        edit_multiple:"Je nahráno několik obrázků. Vyberte obrázky, u kterých chcete změnit zvětšení. Po výběru budou tyto obrázky znovu zvětšeny na nové zvětšení.",
        download_confirm:"Některé snímky se stále zpracovávají. Opravdu chcete uložit všechny upravené obrázky? Když opakovaně uložíte stejný obrázek, počet uložených obrázků nebude znovu odečten.",
        waiting_save:"Některé snímky se stále zpracovávají. Uložte prosím později.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler Online",
        hd:" HD obraz(y)",
        watermarks:"bez vodoznaků lze v současné době stáhnout.",
        view_details:"Zobrazit podrobnosti",
        loading:"Načítání…",
    },
    content:{
        failed:"neúspěšné",
        completed:"dokončeno",
        processing:"Zpracovává se",
        img_processing:"Zpracovává se…",
        img_failed:"Zpracování se nezdařilo",
        uploading:"nahrávání",
        img_uploading:"Nahrávání…",
        wait_upoading:"Čekání na nahrání…",
        waiting:"Čekání",
        img_waiting:"Čekání…",
        empty:"Prázdný",
        magnification:"Zvětšení:",
        drop:"Nebo sem umístěte soubor s obrázkem pro vylepšení a vylepšení!",
        original:"Originál:",
        output:"Výstup:",
        img_rendering1:"Váš obrázek byl upscalován.",
        img_rendering2:"Pracujeme na vykreslení vysoce kvalitního obrázku pro náhled, čekejte prosím...",
        no_watermark:"Po uložení nemá obrázek žádný vodoznak.",
    },
    banner_msg:"Vyberte si plán pro Image Upscale",
    monthly:"MĚSÍČNÍ",
    lifetime:"ŽIVOT",
    choose_plan:"Vyberte si svůj plán na základě počtu obrázků",
    return_home:"Gratulujeme! Úspěšně jste upgradovali. Vraťte se prosím na domovskou stránku a použijte tento produkt.",
    congratulations:"Gratulujeme! Úspěšně jste upgradovali. Výhody byly vázány na e-mailovou adresu, kterou jste zanechali při upgradu. Použijte prosím účet registrovaný nebo propojený s e-mailovou adresou na",
    login_benefits:"přihlášení pro využívání výhod",
    no_registered:". Pokud jste se nezaregistrovali nebo nepropojili účet s e-mailovou adresou, prosím",
    register_account:"použít e-mailovou adresu k registraci účtu",
    other_accounts:" nebo k této e-mailové adrese propojte jiné účty, abyste mohli využívat výhody.",
    btn_close:"Zavřít",
    free:"Volný, uvolnit",
    btn_get_started:"Začít",
    // access_to:"Přístup k",
    upscale_images:"Upscale obrázky",
    up_to:"Až do ",
    per_image:" za obrázek",
    resolution_of:"Až do rozlišení",
    default_level:"Upscale obrázky ve výchozí úrovni",
    image_downloads:"2 stahování HD obrázků bez vodoznaku",
    unlimited_image:"Neomezené stahování obrázků s vodoznakem",
    SHA256_encryption:"šifrovací technika SHA256",
    mon:"Měsíční",
    images:"snímky",
    high_resolution:" s kvalitou vysokého rozlišení",
    tax_incl:"Včetně daně.",
    image:"obraz",
    secure_checkout:"Bezpečnostní prohlídka",
    everything:"Vše zdarma a",
    upscaling_levels:"Lze vybrat všechny úrovně upscalingu",
    unlimited_image_without:"Neomezené stahování obrázků bez vodoznaku",
    viewable_editing:"Zobrazit historii úprav je platná pro ",
    days:" dny",
    high_level:"Vysoká úroveň",
    priority_processing:" prioritní zpracování",
    left:"Život",
    resolution:" rozlišení",


    "history_will":"Vyprší po",
    "history.days":"dny",
    "history.hours":"hodin",
    "expired":"Platnost vypršela",
    "access_to":"S bezplatnou zkušební verzí můžete pouze",
    "pricing.upload_images":"Nahrajte obrázky",
    "pricing.under":"pod",
    "pricing.images":"snímky",
    "pricing.without_watermark":"bez vodoznaku",
    "pricing.process_images":"Zpracovat snímky až do",
    "pricing.pixels":"pixelů",
    "pricing.enjoy_limited":"Užijte si omezené upscale třídy",
    "pricing.download":"Stažení",
    "pricing.HD_images":"HD obrázky bez vodoznaku",
    "pricing.and_you":"A můžete trpět",
    "pricing.slow_upscaling":"pomalé upscaling",
    "pricing.lower_priority":"nižší prioritu",
    "pricing.without":"bez vodoznaku",
    "pricing.tax":"Daň je zahrnuta v prodejní ceně a bude vypočítána automaticky na základě vaší země a regionu. V nákupním košíku můžete vidět podrobnou výši daně. Vaše konečná částka platby bude stejná jako zobrazená cena.",
    "pricing.you_can":"S předplatným můžete",
    "pricing.up_to":"Nahrajte obrázky až do",
    "pricing.upscale_images":"Upscale obrázky s",
    "pricing.no_watermark":"žádný vodoznak",
    "pricing.enhance":"Zlepšit",
    "pricing.or_more":"obrázky nebo více",
    "pricing.in_batch":"v dávce",
    "pricing.enlarge_images":"Zvětšit obrázky v",
    "pricing.and":"a",
    "pricing.times_with":"časy bez omezení",
    "pricing.enjoy":"Užívat si",
    "pricing.of_history":"doby ukládání historie",
    "pricing.experience":"Zkušenosti",
    "pricing.fast_upscaling":"rychlé upscaling",
    "pricing.higher_priority":"vyšší prioritu",
    "pricing.early_access":"Včasný přístup k novým funkcím",
    "pricing.cancel_anytime":"Kdykoli zrušit",
    "pricing.lifetime_license":"S doživotní licencí můžete",
    "pricing.and_there":"A bude",
    "pricing.no_expiration":"žádné datum vypršení platnosti",
    "pricing.unless":"pokud vám nedojdou všechny upscale",

    "buynow.pop.credit":"kredit",
    "buynow.pop.credits":"kredity",

    "isUnderequityTip_msg1":"Vybrali jste {%} obrázků pro dávkové zpracování a nezbývá dostatek výhod. Stále potřebujete {%} kreditů (aktuálně zbývá {%} kreditů), Pokud potřebujete zpracovat, zakupte si prosím výhody a pokračujte zpracování snímků.",
    "isUnderequityTip_msg2":"Vybrali jste {%} obrázků pro dávkové zpracování a nezbývá dostatek výhod. Stále potřebujete {%} kreditů (aktuálně zbývá {%} obrázků výhod), Pokud je potřebujete zpracovat, kupte si výhody pokračovat ve zpracování snímků.",
    "isUnderequityTip_msg3":"Vybrali jste {%} obrázků pro dávkové zpracování a nezbývá dostatek výhod, stále potřebujete {%} kreditů (v současné době zbývá {%} kreditů, zbývá {%} obrázků výhod), Pokud potřebujete Chcete-li snímky nadále zpracovávat, zakupte si výhody.",
    "btn_buy_now":"Koupit nyní",
    "isEquityDepletionTip_msg":"Vaše současné výhody byly vyčerpány, zakupte si výhody pro dávkové zpracování.",
}